import 'slick-carousel/slick/slick.min';
import Modernizr from 'modernizr';


export class SliderCpnt {
    constructor()
    {
        this.initializeRelatedPost();
        this.initializeHomeSlider();
        this.initializeHomePages();
        this.initializeHomeInspirations();
        this.initializeHomeHighlight();
        this.initializeHomeDestination();
    }
    
    initializeRelatedPost()
    {
        
        let $sliders = $( '.relatedpostSlider' );
        
        $sliders.each( function () {
            let id_slider = $( this ).attr( 'id' ),
                $items    = $( '#' + id_slider + ' .relatedpostItem' ),
                $slider   = $( '#' + id_slider );
            
            if ( $items.length > 3 || ($items.length > 2 && window.matchMedia( "(max-width: 739px)" ).matches) ) {
                let settings = {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    infinite: false,
                    variableWidth: true,
                    initialSlide: $items.length - 3,
                    responsive: [
                        {
                            breakpoint: 959,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 2,
                                initialSlide: 0,
                                arrows: false,
                            }
                        },
                        {
                            breakpoint: 739,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                initialSlide: 0,
                                arrows: false,
                            }
                        },
                    ]
                };
                $slider.slick( settings );
            }
        } );
    }
    
    initializeHomeSlider()
    {
        //Slider home
        let $slider        = $( '.sliderList' ),
            sliderItem     = '.sliderItemPhoto',
            $currentSlider = $( '.sliderList [data-slide-current]' );
        
        if ( $( sliderItem ).length > 0 ) {
            $slider.slick(
                {
                    slide: sliderItem,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    speed: 1000,
                    arrows: true,
                    dots: false,
                    fade: true,
                    cssEase: 'linear',
                    prevArrow: $( "[data-slide-arrow ='prev']" ),
                    nextArrow: $( "[data-slide-arrow ='next']" ),
                } );
        }
        
        $slider.on( 'beforeChange', function ( event, slick, currentSlide, nextSlide ) {
            $currentSlider.html( '0' + (nextSlide + 1) );
        } );
        
    }
    
    initializeHomePages()
    {
        
        let $slider        = $( '.pageHighlightList' ),
            sliderItem     = '.pageHighlightItem',
            $currentSlider = $( '.stratePages [data-slide-pages-current]' );
        
        if ( ($( sliderItem ).length > 1 && window.matchMedia( "(min-width: 959px)" ).matches) || ($( sliderItem ).length > 2 && window.matchMedia( "(max-width: 959px)" ).matches) || ($( sliderItem ).length > 1 && window.matchMedia( "(max-width: 739px)" ).matches) ) {
            $slider.slick(
                {
                    slide: sliderItem,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 800,
                    autoplay: false,
                    arrows: true,
                    dots: false,
                    cssEase: 'linear',
                    prevArrow: $( "[data-slide-pages-arrow ='prev']" ),
                    nextArrow: $( "[data-slide-pages-arrow ='next']" ),
                    responsive: [
                        {
                            breakpoint: 1279,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                variableWidth: true,
                                arrows: true,
                            }
                        },
                        {
                            breakpoint: 959,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                initialSlide: 0,
                                variableWidth: true,
                                arrows: false,
                            }
                        },
                        {
                            breakpoint: 739,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                initialSlide: 1,
                                variableWidth: true,
                                arrows: false,
                                centerMode: true,
                            }
                        },
                    ]
                } );
            
        }
        
        $slider.on( 'beforeChange', function ( event, slick, currentSlide, nextSlide ) {
            $currentSlider.html( '0' + (nextSlide + 1) );
        } );
        
    }
    
    initializeHomeInspirations()
    {
        
        let $slider    = $( '.entityList--home' ),
            sliderItem = '.entityList--home .entityItem';
    
        if ( ($( sliderItem ).length > 0 && window.matchMedia( "(min-width: 959px)" ).matches) || ($( sliderItem ).length > 3 && window.matchMedia( "(max-width: 959px)" ).matches) || ($( sliderItem ).length > 1 && window.matchMedia( "(max-width: 739px)" ).matches) ) {
        
            $slider.slick(
                {
                    slide: sliderItem,
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: true,
                    dots: false,
                    variableWidth: true,
                    cssEase: 'linear',
                    responsive: [
                        {
                            breakpoint: 959,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                arrows: false,
                                variableWidth: true,
                            }
                        },
                        {
                            breakpoint: 739,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                arrows: false,
                                variableWidth: true,
                            }
                        },
                    ]
                } );
        }
        
    }
    
    initializeHomeHighlight()
    {
        
        let $slider    = $( '.strateHighlight .posthighlightList' ),
            sliderItem = '.posthighlightList .posthighlightItem';
        
        if ( $( sliderItem ).length > 2 && window.matchMedia( "(max-width: 739px)" ).matches ) {
            $slider.slick(
                {
                    slide: sliderItem,
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: false,
                    dots: false,
                    variableWidth: true,
                    cssEase: 'linear',
                    centerMode: true,
                    initialSlide: 1,
                } );
        }
    }
    
    initializeHomeDestination()
    {
        
        let $slider    = $( '.strateMap .mapList' ),
            sliderItem = '.mapList .mapItem';
        
        if ( sliderItem.length > 0 && window.matchMedia( "(max-width: 959px)" ).matches || Modernizr.touchevents) {
            $slider.slick(
                {
                    slide: sliderItem,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    autoplay: false,
                    arrows: false,
                    dots: false,
                    variableWidth: true,
                    centerMode: true,
                    cssEase: 'linear',
                    initialSlide: 1,
                    responsive: [
                        {
                            breakpoint: 959,
                            settings: {
                                centerMode: false,
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                variableWidth: true,
                                initialSlide: 1,
                            }
                        },
                        {
                            breakpoint: 739,
                            settings: {
                                centerMode: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                variableWidth: true,
                                initialSlide: 1,
                            }
                        },
                    ]
                } );
        }
        
    }
    
}
